export const normalizeConsentLocale = (locale?: string | null) => {
    const normalizedLocale = locale?.trim();

    return normalizedLocale && normalizedLocale.length > 0 ? normalizedLocale : undefined;
};

export const buildConsentLocaleHeaders = (locale?: string | null) => {
    const normalizedLocale = normalizeConsentLocale(locale);

    return normalizedLocale ? { "Accept-Language": normalizedLocale } : undefined;
};

export const buildConsentJsonLocaleHeaders = (locale?: string | null) => ({
    "Content-Type": "application/json",
    ...buildConsentLocaleHeaders(locale),
});
